export const APP_DEFAULT_PATH = '/home';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

const config = {
  fontFamily: `'Poppins', sans-serif`
};

export default config;
